module.exports = __webpack_public_path__ + "media/images/main/work12-14b61665015f68120498776a9ba7e274.jpg";